import { render, staticRenderFns } from "./curveLayerDrawer.vue?vue&type=template&id=2a8b1560&"
import script from "./curveLayerDrawer.vue?vue&type=script&lang=ts&"
export * from "./curveLayerDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./curveLayerDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports